import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { FormikSelect } from "@qgiv/core-donor";
import ProductAttributeOption from "./ProductAttributeOption";

const ProductAttributes = ({
    attributeKeysToArray = [],
    attributeLabel,
    disabledBySelectionList,
    disabledList,
    fields,
    Field_Data_Id = undefined,
}) => {
    const { values, setFieldValue } = useFormikContext();

    // We need to watch for a selection that is changed to the point where it may be
    // possible to have a disabled option selected.  In this case we need to deselect
    // any that should be disabled to force the user to make a new selection
    useEffect(() => {
        if (disabledBySelectionList && disabledBySelectionList.length > 0) {
            // eslint-disable-next-line array-callback-return
            attributeKeysToArray.map((attributeKey) => {
                disabledBySelectionList.forEach((disabledOption) => {
                    if (values[attributeKey] === disabledOption) {
                        setFieldValue(`${attributeKey}`, "");
                    }
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabledBySelectionList, values]);

    return (
        <div className="grid">
            {Object.values(fields).map((field, index) => {
                const { id, text, data } = field;
                const name = `Attribute_${id}`;

                const entityReplacedAttributeLabel =
                    text && text.length > 0
                        ? attributeLabel.replace("%Attribute%", text)
                        : "";

                const attributeRequiredAriaLabel =
                    values[name].length > 0
                        ? "  "
                        : "A selection is required for this attribute.";

                const attributeAriaLabel = `${entityReplacedAttributeLabel}: ${attributeRequiredAriaLabel}`;

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index} className="col col--12">
                        <FormikSelect
                            label={entityReplacedAttributeLabel}
                            name={name}
                            type="select"
                            id={name}
                            ariaRequired="true"
                            ariaLabel={attributeAriaLabel}
                        >
                            {data.map((productOption, i) => {
                                // Taking the passed list of disabled options, if the productOption is an
                                // exact match to string in disabledList then disabled equals true.
                                // If it is not a match then -1 is returned and disabled is false
                                const disabled =
                                    disabledList && disabledList.length > 0
                                        ? disabledList.indexOf(
                                              productOption,
                                          ) !== -1
                                        : false;
                                const disabledBySelection =
                                    !Field_Data_Id &&
                                    disabledBySelectionList &&
                                    disabledBySelectionList.length > 0
                                        ? disabledBySelectionList.indexOf(
                                              productOption,
                                          ) !== -1
                                        : false;

                                return (
                                    <ProductAttributeOption
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={i}
                                        productOption={productOption}
                                        disabled={
                                            disabled || disabledBySelection
                                        }
                                    />
                                );
                            })}
                        </FormikSelect>
                    </div>
                );
            })}
        </div>
    );
};

ProductAttributes.propTypes = {
    attributeKeysToArray: PropTypes.arrayOf(PropTypes.string),
    attributeLabel: PropTypes.string.isRequired,
    disabledBySelectionList: PropTypes.arrayOf(PropTypes.string).isRequired,
    disabledList: PropTypes.arrayOf(PropTypes.string).isRequired,
    fields: PropTypes.shape({}).isRequired,
    Field_Data_Id: PropTypes.string,
};

export default ProductAttributes;
